import classNames from "classnames";
import Sb from "../abstract/StatefulBehavior";
import Percolator from "../../helpers/Percolator";
import ToggleOverlay from "./ToggleOverlay";
import ToggleSearchOverlay from "./ToggleSearchOverlay";

export default class ControlOverlays extends Sb {
  constructor(el, props, refs) {
    super();

    if (!refs.toggleSearchOverlay || !refs.toggleMainOverlay) return null;

    this.refs = refs;
    this.el = el;
    this.state = {
      active: null,
    };
    this.initClassName = this.el.parentElement.className;

    const percolator = new Percolator();

    this.mainOverlay = percolator.loadBehavior(
      refs.toggleMainOverlay,
      ToggleOverlay,
      {
        onOpen: this.handleOpenMainOverlay,
        onClose: this.handleDirectlyCloseOverlay,
        ...props.mainOverlayProps,
      }
    );
    this.searchOverlay = percolator.loadBehavior(
      refs.toggleSearchOverlay,
      ToggleSearchOverlay,
      {
        onOpen: this.handleOpenSearchOverlay,
        onClose: this.handleDirectlyCloseOverlay,
      }
    );
  }

  get timeoutDuration() {
    return 150;
  }

  update = () => {
    const { active } = this.state;
    this.el.parentElement.className = classNames(this.initClassName, {
      "overlay-is-open": !!active,
      "has-scroll-lock": !!active,
    });
  };

  handleOpenMainOverlay = () => {
    this.searchOverlay.closeOverlay();
    setTimeout(() => {
      this.setState({ active: "main" });
    }, this.timeoutDuration);
  };

  handleOpenSearchOverlay = () => {
    this.mainOverlay.closeOverlay();
    setTimeout(() => {
      this.setState({ active: "search" });
    }, this.timeoutDuration);
  };

  handleDirectlyCloseOverlay = () => {
    setTimeout(() => {
      this.setState({ active: null });
    }, this.timeoutDuration);
  };
}
